import { isServiceWorkerSupported } from "../../utils/browser";
import { listenForResponse } from "./listeners";
import { MessagePayload } from "./types";

export const serviceWorkerQuery = async <T>(
  data: Omit<MessagePayload, "requestId">
) => {
  if (!isServiceWorkerSupported()) {
    return Promise.reject(new Error("Service workers are not supported"));
  }

  return new Promise<T | null>(async (resolve, reject) => {
    await navigator.serviceWorker.ready;
    const requestId = `${data.type}-${Date.now()}-${Math.random()}`;

    listenForResponse<T>(navigator.serviceWorker, { ...data, requestId })
      .then((res) => resolve(res))
      .catch(reject);

    const registration = await navigator.serviceWorker.getRegistration();
    registration?.active?.postMessage({ ...data, requestId });
  });
};

export const broadCastChannelQuery = async <T>(
  channelId: string,
  data: Omit<MessagePayload, "requestId">
) => {
  return new Promise<T | null>((resolve, reject) => {
    const channel = new BroadcastChannel(channelId);
    const requestId = `${data.type}-${Date.now()}-${Math.random()}`;

    listenForResponse<T>(channel, { ...data, requestId })
      .then((res) => resolve(res))
      .catch(reject);

    channel.postMessage({ ...data, requestId });
  });
};
